import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { frame: String }

  connect() {
    this.desktop = window.matchMedia("(min-width: 901px)")
    this.updateTurboTarget = this.updateTurboTarget.bind(this)
    this.desktop.addEventListener("change", this.updateTurboTarget)
    this.updateTurboTarget()
  }

  disconnect() {
    this.desktop.removeEventListener("change", this.updateTurboTarget)
  }

  select() {
    if (!this.desktop.matches) return

    document.querySelectorAll("[data-controller~='concept-link']").forEach((marker) => {
      marker.classList.remove("is-selected")
      marker.removeAttribute("aria-current")
    })

    this.element.classList.add("is-selected")
    this.element.setAttribute("aria-current", "page")
  }

  updateTurboTarget() {
    if (this.desktop.matches) {
      this.element.dataset.turboFrame = this.frameValue
    } else {
      delete this.element.dataset.turboFrame
    }
  }
}
